import { Button } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { Header, HeaderDialog } from 'components';
import { IHeaderDialogProps } from 'components/foundation/dialogs/HeaderDialog/HeaderDialog';
import ManageListTableContainer from 'containers/jsa-reports/ManageListTableContainer/ManageListTableContainer';
import { t } from 'i18next';
import { ReactNode } from 'react';

export interface IManageListTableDialogProps
  extends Omit<IHeaderDialogProps, 'children' | 'showBackArrowAsClose' | 'size'> {
  addText?: string;
  onAdd: () => void;
  children: ReactNode;
}

export default function ManageListTableDialog({
  children,
  addText = t('Add'),
  onAdd,
  className,
  ...headerDialogProps
}: IManageListTableDialogProps) {
  const classes = classNames('manage-list-table-dialog', className);

  return (
    <HeaderDialog showBackArrowAsClose={true} className={classes} size="full" {...headerDialogProps}>
      <Header>
        <Button onClick={onAdd} type="secondary">
          {addText}
        </Button>
      </Header>
      <ManageListTableContainer className="pt-9">{children}</ManageListTableContainer>
    </HeaderDialog>
  );
}
